var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Languages',{staticClass:"languages gui__element gui__element--top-right"}),_c('ul',_vm._l((_vm.tours),function(tour){return _c('li',{key:tour.id},[_c('a',{attrs:{"href":`/${_vm.$locale}/virtual-tour/${tour.slug}`}},[_vm._v(_vm._s(tour.title))])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }